import { configureStore } from '@reduxjs/toolkit';
import machineServiceSlice from './slices/machineApi';
import orderSlice from './slices/orderApi';
import orderDetailSlice from './slices/orderDetailApi';
import userSlice from './slices/userApi';
import sidebarSlice from './slices/sidebarSlice';
import thunk from 'redux-thunk';

export default configureStore({
  reducer: {
    sidebar: sidebarSlice,
    machineServiceApi: machineServiceSlice,
    orderApi: orderSlice,
    orderDetailApi: orderDetailSlice,
    userApi: userSlice,
  },
  middleware: [thunk]
});
